import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/header'
import '../styles/main.scss'
import '../styles/prism.css'
import Footer from '../components/Footer/Footer.jsx'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        {
          name: 'description',
          content: data.site.siteMetadata.description,
        },
        {
          name: 'keywords',
          content:
            'fullstack, developer, frontend, projects, go, reactjs, javascript, docker, es6, neo4j, dgraph, golang',
        },
        {
          name: 'Cache-control',
          content: 'public, max-age=691200',
        },
      ]}
    >
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/animate.css@3.5.2/animate.min.css"
      />
    </Helmet>
    <Header siteTitle={data.site.siteMetadata.title} />
    <div>{children()}</div>
    <Footer info={data} />
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
        author
        description
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js